// src/components/Sales/SalesTable.jsx
import React from 'react';
import { Eye } from 'lucide-react';

const SalesTable = ({ sales, onViewDetails, isLoading }) => {
  const formatCurrency = (amount) => {
    return `Rs. ${Number(amount || 0).toLocaleString()}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  const calculateProfit = (totalValue, totalCost) => {
    const profit = Number(totalValue || 0) - Number(totalCost || 0);
    return profit;
  };

  if (isLoading) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Shop Name</th>
              <th>Inventory</th>
              <th>Total Value</th>
              <th>Total Cost</th>
              <th>Profit</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                Loading sales data...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  if (!sales || sales.length === 0) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Shop Name</th>
              <th>Inventory</th>
              <th>Total Value</th>
              <th>Total Cost</th>
              <th>Profit</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                No sales match the current filter.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Shop Name</th>
            <th>Inventory</th>
            <th>Total Value</th>
            <th>Total Cost</th>
            <th>Profit</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sales.map((sale) => {
            const profit = calculateProfit(sale.totalValue, sale.totalCost);
            const profitColor = profit >= 0 ? '#28a745' : '#dc3545';
            
            return (
              <tr key={sale.id}>
                <td>{sale.invoiceNumber || 'N/A'}</td>
                <td>{sale.customer?.shopName || sale.customer?.name || 'Cash Customer'}</td>
                <td>{sale.inventory?.name || 'N/A'}</td>
                <td>{formatCurrency(sale.totalValue)}</td>
                <td>{formatCurrency(sale.totalCost)}</td>
                <td style={{ color: profitColor, fontWeight: 'bold' }}>
                  {formatCurrency(profit)}
                </td>
                <td>{formatDate(sale.createdAt)}</td>
                <td>
                  <button 
                    className="btn btn-action btn-view" 
                    onClick={() => onViewDetails(sale)}
                    style={{ 
                      backgroundColor: '#17a2b8',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px'
                    }}
                  >
                    <Eye size={16} />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SalesTable;